import { api } from "./api.service";

export type PaymentStatus =
  | "PENDING"
  | "AUTHORIZED"
  | "PAID"
  | "REFUNDED"
  | "CHARGEBACK"
  | "CANCELLED"
  | "FAILED"
  | string;

export type PaymentMethod =
  | "PIX"
  | "CREDIT_CARD"
  | "DEBIT_CARD"
  | "BOLETO"
  | "CASH"
  | "TRANSFER"
  | string;

export type PaymentsReportFilters = {
  start?: string;
  end?: string;
  paymentMethod?: string[]; // múltiplo
  status?: string[]; // múltiplo
  minValue?: string;
  maxValue?: string;
  planId?: string;
  doctorId?: string;
  patientId?: string;
  q?: string;
  page?: number;
  perPage?: number;
};

export type PaymentsReportRow = {
  id: string;
  issuedAt: string;
  paidAt?: string | null;
  dueDate?: string | null;
  status: PaymentStatus;
  paymentMethod: PaymentMethod;
  value: number;
  currency: string;
  fee?: number | null;
  transactionId?: string | null;
  plan?: {
    id: string;
    name: string;
    value: number;
    currency: string;
    level?: number | null;
  };
  patient?: { id: string; name: string; email?: string };
  doctor?: { doctorId: string; name?: string | null; CRM?: string | null; percentual?: string | null };
  appointment?: {
    id: string;
    status: string;
    startTime: string;
    endTime: string;
    local?: { id: string; localName?: string | null; city?: string | null; state?: string | null } | null;
  } | null;
  computed?: { doctorShare: number; platformShare: number };
};

export type PaymentsReportResponse = {
  totals: {
    payments: number;
    gross: number;
    fees: number;
    doctorShare: number;
    platformShare: number;
  };
  pagination: {
    page: number;
    perPage: number;
    totalItems: number;
    totalPages: number;
  };
  payments: PaymentsReportRow[];
};

export async function getPaymentsReport(filters: PaymentsReportFilters): Promise<PaymentsReportResponse> {
  const { data } = await api.get("/reports/payments", {
    params: {
      start: filters.start,
      end: filters.end,
      paymentMethod: filters.paymentMethod?.length ? filters.paymentMethod.join(",") : undefined,
      status: filters.status?.length ? filters.status.join(",") : undefined,
      minValue: filters.minValue,
      maxValue: filters.maxValue,
      planId: filters.planId,
      doctorId: filters.doctorId,
      patientId: filters.patientId,
      q: filters.q,
      page: filters.page,
      perPage: filters.perPage,
    },
  });

  return data;
}
